import { ActivatedContractBenefitList } from "./ActivatedContractTypePage";
import { TypeCardContainer, UpgradeContractFooter } from "./SelectTypePage";
import PackageInformation from "./PackageInformation";
import { StandardUpgradeCard } from "./StandardCard";
import { FlowPage } from "../../formatting/Page";
import CardSection, { TitleSection } from "../../formatting/CardSection";
import { SIMPLE_BENEFITS } from "./SimpleCard";
import { GetContractUpgradeProductsResponse } from "./ContractTypePage";
import { ContractPath } from "../routing/ContractPath";
import { useRelativeUrls } from "../routing/ContractFormRoutes";
import { RelativeNavigationFooter } from "../RouterFooterLink";
import ContractPageCard from "../../formatting/ContractPageCard";
import PageCard from "../../formatting/PageCard";
import MemberUpgradeText from "./MemberUpgradeText";
import { PremiumUpgradeCard } from "./PremiumCard";

export default function SimpleContractPage({
  upgrade,
  page,
}: {
  page: ContractPath;
  upgrade: GetContractUpgradeProductsResponse;
}) {
  const relativeUrls = useRelativeUrls(page);
  return (
    <FlowPage>
      <ContractPageCard>
        <TitleSection title="Du har nå Enkel-pakken!">
          <p>I kontrakten har du tilgang til:</p>
          <ActivatedContractBenefitList benefits={SIMPLE_BENEFITS} />
        </TitleSection>
        <RelativeNavigationFooter using={relativeUrls} />
      </ContractPageCard>
      <PageCard>
        <CardSection
          title="Du kan fortsatt oppgradere!"
          ingress={
            <>
              Hvis du ønsker å signere med BankID kan du fortsatt oppgradere
              kontrakten her. <MemberUpgradeText />
            </>
          }
        >
          <div>
            <TypeCardContainer>
              <PremiumUpgradeCard upgrade={upgrade} />
              <StandardUpgradeCard upgrade={upgrade} />
            </TypeCardContainer>
            <UpgradeContractFooter />
          </div>
        </CardSection>
        <PackageInformation complete simple standard />
      </PageCard>
    </FlowPage>
  );
}
